import { render, staticRenderFns } from "./field-location.vue?vue&type=template&id=2dc50fd9&"
import script from "./field-location.vue?vue&type=script&lang=js&"
export * from "./field-location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports